// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { PublicationVersionFile } from "./PublicationVersionFile";
import {
  PublicationVersionFileFromJSON,
  PublicationVersionFileFromJSONTyped,
  PublicationVersionFileToJSON,
  PublicationVersionFileToJSONTyped,
} from "./PublicationVersionFile";

/**
 *
 * @export
 * @interface PagePublicationVersionFile
 */
export interface PagePublicationVersionFile {
  /**
   *
   */
  total: number;
  /**
   *
   */
  items: Array<PublicationVersionFile>;
  /**
   *
   */
  limit?: number | null;
  /**
   *
   */
  offset?: number | null;
}

/**
 * Check if a given object implements the PagePublicationVersionFile interface.
 */
export function instanceOfPagePublicationVersionFile(
  value: object
): value is PagePublicationVersionFile {
  if (!("total" in value) || value["total"] === undefined) return false;
  if (!("items" in value) || value["items"] === undefined) return false;
  return true;
}

export function PagePublicationVersionFileFromJSON(json: any): PagePublicationVersionFile {
  return PagePublicationVersionFileFromJSONTyped(json, false);
}

export function PagePublicationVersionFileFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PagePublicationVersionFile {
  if (json == null) {
    return json;
  }
  return {
    total: json["total"],
    items: (json["items"] as Array<any>).map(PublicationVersionFileFromJSON),
    limit: json["limit"] === undefined ? undefined : json["limit"] === null ? null : json["limit"],
    offset:
      json["offset"] === undefined ? undefined : json["offset"] === null ? null : json["offset"],
  };
}

export function PagePublicationVersionFileToJSON(json: any): PagePublicationVersionFile {
  return PagePublicationVersionFileToJSONTyped(json, false);
}

export function PagePublicationVersionFileToJSONTyped(
  value?: PagePublicationVersionFile | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    total: value["total"],
    items: (value["items"] as Array<any>).map(PublicationVersionFileToJSON),
    limit: value["limit"],
    offset: value["offset"],
  };
}
